import { Box, InfoIcon, Tooltip, Typography } from '@methanesat/ui-components';
import { ReactElement } from 'react';

export const EmissionTitle = ({
    Icon,
    'data-testid': dataTestId,
    emissionTypeLabel,
    emissionsHeadline,
    tooltip
}: {
    Icon?: ReactElement;
    emissionTypeLabel: string;
    'data-testid': string;
    emissionsHeadline: ReactElement;
    tooltip?: string | ReactElement;
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                width: '100%',
                gap: 1
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                {Icon}
                <Typography
                    data-testid={dataTestId}
                    variant="h6"
                    sx={{
                        display: 'flex',
                        justifyContent: 'start',
                        fontWeight: 'bold',
                        flex: '1 0 auto',
                        lineHeight: '1.3rem'
                    }}
                >
                    {emissionTypeLabel}
                </Typography>
                {tooltip && (
                    <Tooltip
                        title={tooltip}
                        enterTouchDelay={0}
                        leaveTouchDelay={3000}
                        sx={{
                            marginLeft: 0.5,
                            fontSize: 20
                        }}
                    >
                        <InfoIcon />
                    </Tooltip>
                )}
            </Box>
            <Box
                sx={{
                    ...(Icon && { marginLeft: 'calc(24px + 16px)' }) // icon width + margin
                }}
            >
                {emissionsHeadline}
            </Box>
        </Box>
    );
};
